import ApiService from "@/core/services/api.service";

// action types
export const LAST_ODATA_BOOKINGS = "lastODataBookings";
export const GET_ODATA_BOOKING = "getODataBooking";
export const GET_ODATA_BOOKINGS = "getODataBookings";
// mutation types
export const SET_ODATA_BOOKINGS = "setODataBookings";
export const SET_ODATA_BOOKING = "setODataBooking";
export const SET_ERROR = "setError";
//const urlBase = 'https://apifacturacionbot.contemporaseguros.com/OdataFacturacionComision'
// const urlBase = 'https://localhost:44396'
const state = {
  errors: null,
  bookings: []
};

const actions = {
  [LAST_ODATA_BOOKINGS](context) {
    return new Promise(resolve => {
      //ApiService.setHeader();
      ApiService.get({action: `/OdataFacturacionComision/odatareserva/odata/Reserva`}, '?$top=7&$skip=0&$count=true&$orderby=FechaReserva desc')
        .then(({ data }) => {
          context.commit(SET_ODATA_BOOKINGS, data);//no guardamos el estado
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_ODATA_BOOKING](context, bookingInfo) {
    ////console.log(('iniciando');
    return new Promise(resolve => {
      //ApiService.setHeader();
      ApiService.get({action: `/facturacioncomisionapi/reservaapi/api/reserva/v1/reserva/${bookingInfo.codigoReserva}` }, bookingInfo)
        .then(({ data }) => {
          context.commit(SET_ODATA_BOOKING, data);//no guardamos el estado
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_ODATA_BOOKINGS](context, query) {

    let { page , page_size, filter } = query;
    filter = (filter === undefined) ? "" : filter;
    let url = `?$count=true${filter}`;

    if(page_size !== -1) {
      let skip = (page - 1) * page_size;
      url = `?$top=${page_size}&$skip=${skip}&$count=true${filter}`;
    }

    return new Promise(resolve => {
      //ApiService.setHeader();
      //console.log(("url",url)
       ApiService.get({action: `/OdataFacturacionComision/odata/FacturacionComision`}, url)
        .then(({ data }) => {
          context.commit(SET_ODATA_BOOKINGS, data);//no guardamos el estado
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response)
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_ODATA_BOOKINGS](state, bookings) {
    state.error = {};
    state.bookings = bookings;
  },
  [SET_ODATA_BOOKING](state, booking) {
    state.error = {};
    state.booking = booking;
  }
};

export default {
  state,
  actions,
  mutations
};
